import styled from "styled-components";
import "./iphone.scss";
import { toTime } from "helpers/dateHelper";
import { EmptyAvatar } from "components/_Icons/EmptyAvatar";
import _ from "lodash";

type PostComment = {
  id: string;
  author: string;
  avatarUrl?: string;
  text: string;
  time: string;
  likes?: number;
  replies?: PostComment[];
};

const Device = styled.div`
  position: relative;
  width: ${360 - (360 / 100) * 15}px;
  height: ${740 - (740 / 100) * 15}px;
  margin: 0 auto;
  background: #0d0d0d;
  border-radius: 42px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35), inset 0 0 0 2px #222;
  padding: 14px;
`;

const Bezel = styled.div`
  width: 100%;
  height: 100%;
  background: #0a0a0a;
  border-radius: 32px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Notch = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: ${160 - (160 / 100) * 15}px;
  height: ${28 - (28 / 100) * 15}px;
  background: #000;
  border-radius: 20px;
  box-shadow: 0 0 0 2px #0a0a0a;
  z-index: 3;
`;

const Screen = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #0f172a; /* slate-900 */
  color: #e2e8f0; /* slate-200 */
`;

const StatusBar = styled.div`
  height: ${44 - (44 / 100) * 15}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 12px;
  color: #cbd5e1;
`;

const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: rgba(15, 23, 42, 0.9);
  border-bottom: 1px solid rgba(148, 163, 184, 0.15);
  position: sticky;
  top: 0;
  z-index: 2;
`;

const Avatar = styled.div<{ src?: string }>`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: ${({ src }) => (src ? `url(${src}) center/cover` : "#1f2937")};
  border: 1px solid rgba(148, 163, 184, 0.25);
  flex-shrink: 0;
`;

const ChatTitle = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;

  strong {
    font-size: 14px;
    color: #e5e7eb;
  }
  span {
    font-size: 11px;
    color: #94a3b8;
  }
`;

const PostCard = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(2, 6, 23, 0.06);
`;

const PostHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
`;

const PostTitle = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  strong {
    font-size: 15px;
    color: #0f172a;
  }
  span {
    font-size: 12px;
    color: #64748b;
  }
`;

const CommentInput = styled.input`
  flex: 1;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  font-size: 13px;
  outline: none;
`;

interface AutomationProps {
  automation: any;
  account: any;
}

function PostWithComments({ automation, account }: AutomationProps) {
  const buildComments = () => {
    let triggerMessage = "Любой комментарий";
    if (automation?.triggerType === "KEYWORD") {
      triggerMessage = _.get(automation, "keywords[0]");
    }
    const userComments = new Array(automation?.replyComments?.length || 1)
      .fill(null)
      .map((x: any, index: number) => ({
        text: triggerMessage,
        userName: "Пользователь",
      }));

    return (
      <>
        <div
          className="comments-list"
          style={{
            overflowY: "auto",
          }}
        >
          {userComments?.map((c: any, index: number) => {
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "flex-start",
                  marginBottom: 10,
                }}
              >
                <EmptyAvatar />
                <div style={{ flex: 1 }}>
                  <div style={{ color: "#0f172a", fontSize: 14 }}>
                    <div className="mb-1 text-sm">{c.userName}</div>
                    <div className="text-xs">{c.text}</div>
                  </div>
                  <div
                    style={{
                      color: "#64748b",
                      fontSize: 12,
                      marginTop: 6,
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                    }}
                  >
                    <button
                      style={{
                        background: "transparent",
                        border: 0,
                        color: "#64748b",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      Ответить
                    </button>
                  </div>

                  {/* Ответы на комментарий сервиса */}
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                      marginTop: 10,
                    }}
                  >
                    <Avatar />
                    <div style={{ flex: 1 }}>
                      <div style={{ color: "#0f172a", fontSize: 14 }}>
                        <div style={{ fontWeight: 700, marginRight: 8 }}>
                          {account?.externalAccountUserName}
                        </div>
                        <div className="text-xs">{automation?.replyComments?.[index]?.text}</div>
                      </div>
                      <div
                        style={{
                          color: "#64748b",
                          fontSize: 12,
                          marginTop: 6,
                          display: "flex",
                          gap: 12,
                          alignItems: "center",
                        }}
                      >
                        <button
                          style={{
                            background: "transparent",
                            border: 0,
                            color: "#64748b",
                            cursor: "pointer",
                            padding: 0,
                          }}
                        >
                          Ответить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <Device>
      <Bezel>
        <Notch />
        <Screen>
          <StatusBar>
            <span style={{ fontSize: "10px" }}>{toTime(new Date())}</span>
            <span style={{ fontSize: "10px" }}>LTE • 100%</span>
          </StatusBar>
          <PostCard>
            <PostHeader>
              <Avatar src={account?.externalAccountPhoto} />
              <PostTitle>
                <strong>{account?.externalAccountUserName}</strong>
                <span>Онлайн</span>
              </PostTitle>
              <div style={{ marginLeft: "auto", color: "#64748b" }}>•••</div>
            </PostHeader>

            {/* Media (1:1) */}
            <div style={{ position: "relative", width: "100%", background: "#000" }}>
              <div
                style={{
                  width: "100%",
                  paddingTop: "100%",
                  background: "linear-gradient(135deg, #0ea5e9 0%, #6366f1 50%, #22c55e 100%)",
                }}
              />
            </div>

            <div className="post-with-comments">
              {buildComments()}

              {/* Add comment */}
              <div className="add-comment">
                <CommentInput placeholder="Добавьте комментарий…" />
              </div>
            </div>
          </PostCard>
        </Screen>
      </Bezel>
    </Device>
  );
}

export default PostWithComments;
